import { Col, Row } from 'antd';
import Text from 'components/Text';
import userSelectors from 'features/user/services/selectors';
import { styled } from 'styled-components';
import WalkInItem from './Item';
import Empty from 'components/Empty';
import Spin from 'components/Spin';
import ButtonRemoveTicket from '../Ticket/ButtonRemoveTicket';
import { useAppDispatch } from 'store/hooks';
import userActions from 'features/user/services/actions';
import { IWaitingListResItem } from 'features/user/services/types/waiting';
import ModalConfirm, { useModalConfirmRef } from 'components/Modal/ModalConfirm';

const WalkInWaitingList = () => {
  const modalConfirm = useModalConfirmRef();
  const dispatch = useAppDispatch();
  const data = userSelectors.getListWalkIn();
  const loading = userSelectors.getWaitingListLoading();
  const isClockIn = userSelectors.staff.isClockIn();
  const activeRemoveWaiting = userSelectors.activeRemoveWaiting();

  const onToggle = () => {
    dispatch(userActions.activeRemoveWaiting(!activeRemoveWaiting));
  };

  const onRemoveTicket = (record: IWaitingListResItem) => () => {
    modalConfirm.current?.open(`Do you like to delete the ticket #${record.ticketNumber}?`, () => {
      dispatch(userActions.removeWaitingTicket(record.checkInId));
    });
  };

  const RowData = () => {
    if (loading) return <Spin />;

    return (
      data.length > 0 ? <Row gutter={[12, 12]}>
        {data.map(o => (
          <Col key={o.checkInId}
            span={12}>
            <WalkInItem data={o} viewOnly={!isClockIn}
              removeMode={activeRemoveWaiting} onRemoveTicket={onRemoveTicket(o)}
            />
          </Col>
        ))}
      </Row> : <Empty description={'Empty walk in ticket'} centerFloating />
    );
  };

  return (
    <Styled>
      <Row align={'middle'} style={{ gap: '8px', marginBottom: '0.5rem', }}>
        <Text variant='H7' mr={1} >In The Queue...</Text>
        <Text style={{ flex: 1 }} />
        {data.length > 0 ? <ButtonRemoveTicket active={activeRemoveWaiting} onToggle={onToggle} /> : <div style={{ height: '2.5rem' }}></div>}
      </Row>
      <div className='box-div-scroll'>
        <RowData />
      </div>
      <ModalConfirm ref={modalConfirm} />
    </Styled>
  );
};

export default WalkInWaitingList;

const Styled = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  padding: 1rem;
  padding-top: 0.5rem;
  padding-bottom: 0;
  background: #8defab4d;
  .box-div-scroll {
    flex: 1;
    margin: 0 -1rem;
    padding: 0 1rem;
    background:#fff;
    padding-top: 1rem;
    overflow-y: scroll;
    scrollbar-width: none; /* Firefox 64 */
    border-right: 1px solid #86909C;
    &::-webkit-scrollbar {
      width: 0px;
    }
  }
  `;